import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import { injectIntl } from "react-intl";
import { useQuery, useMutation, queryCache } from "react-query";
import * as Yup from "yup";
import Alert from 'react-s-alert';
import PageLoading from "../../../components/Loading";
import { InputFloatingLabel } from "../../../formik";
import ArchiveHeader from "../../../components/ArchiveHeader";
import { getSchedule, postSchedule, putSchedule } from '../schedules/xhr';
import { cleanObjectAndReturn } from "../../../helpers/cleanObject"

const SessionForm = ({ intl, match, history, locale, setLocale }) => {

  const editForm = match.params.id ? true : false;

  const { isLoading, isError, error, data: schedule } = useQuery('schedule', getSchedule, {
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  });

  const [postScheduleMutation] = useMutation(postSchedule, {
    onSuccess: (createdSchedule) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          sessions: schedule.sessions.concat([createdSchedule])
        }));
      }
      Alert.success(intl.formatMessage({id: 'session.create-success'}));
      history.push("/sessions");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })
  const addSession = async (values) => {
    Alert.warning(intl.formatMessage({id: "alert.s.session.create_do"}));
    await postScheduleMutation({collection: 'session', schedule: cleanObjectAndReturn(values)})
  };

  const [putScheduleMutation] = useMutation(putSchedule, {
    onSuccess: (updatedSchedule) => {
      if(queryCache.getQueryData('schedule')) {
        queryCache.setQueryData('schedule', schedule => ({
          ...schedule,
          sessions: schedule.sessions.map(session => session._id === updatedSchedule._id ? updatedSchedule : session)
        }))
      }
      Alert.success(intl.formatMessage({ id: 'session.update-success' }));
      history.push("/sessions");
    },
    onError: (err) => {
      Alert.error(intl.formatMessage({ id: err.response.data.message }))
    }
  })

  const editSession = async (values) => {
    Alert.warning(intl.formatMessage({id: "alert.s.session.update_do"}));
    await putScheduleMutation({ collection: 'session',  _id:match.params.id , schedule:cleanObjectAndReturn(values) })
  }

  if (isLoading) {
    return <PageLoading />;
  }

  if (isError) {
    return <span>Error: {error.message}</span>
  }

  return (
    <React.Fragment>
      <ArchiveHeader locale={locale} setLocale={setLocale} intl={intl} title={editForm ? "button.s.session-update" : "button.s.session-create"} back backLink="/sessions" />
      <div className="pad-2rem">
        <Container fluid>
          <Row>
            <Col md={4}>
              <Formik
                validationSchema={
                  Yup.object().shape({
                    name: Yup.string().required(),
                    description: Yup.string(),
                  })
                }
                initialValues={editForm
                  ? {
                    ...schedule.sessions.find(
                      r => r._id === match.params.id
                    )
                  }
                  : {
                    name: match.params.name ? match.params.name : '',
                    description: ''
                  }}
                enableReinitialize={true}
                onSubmit={ async ({ name, description }) => {
                  editForm ? 
                    editSession({ name, description })
                  : addSession({ name, description });
                }}
              >
                {({ values }) => {
                  return (
                    <Form className="floating-label-form">
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        name="name"
                        id="name"
                        placeholder={intl.formatMessage({
                          id: "input.name"
                        })}
                        label={intl.formatMessage({
                          id: "input.name"
                        })}
                        required
                      />
                      <Field
                        component={InputFloatingLabel}
                        type="text"
                        as="textarea"
                        rows={3}
                        name="description"
                        id="description"
                        placeholder={intl.formatMessage({
                          id: "input.description"
                        })}
                        label={intl.formatMessage({
                          id: "input.description"
                        })}
                      />
                      <Button
                        type="submit"
                        variant="primary"
                      >
                        {editForm ? intl.formatMessage({ id: `button.s.session-update` }) : intl.formatMessage({ id: `button.s.session-create` })}
                      </Button>
                    </Form>
                  )
                }}
              </Formik>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};


export default injectIntl(SessionForm)
